module.exports = __webpack_public_path__ + "static/img/IMG_20160307_164959.1d84da1d.jpg";